export enum Action {
  Create = 'CREATE',
  Update = 'UPDATE',
  Delete = 'DELETE',
  Shift = 'SHIFT',
  Duplicate = 'DUPLICATE',
  Refresh = 'REFRESH',
}

export enum ObjectType {
  Task = 'TASK',
  User = 'USER',
  Users = 'USERS',
  Team = 'TEAM',
  Field = 'FIELD',
  Comment = 'COMMENT',
  ConversationComment = 'CONVERSATION_COMMENT',
  Project = 'PROJECT',
  ProjectConversation = 'PROJECT_CONVERSATIONS',
  ProjectPhase = 'PROJECT_PHASE',
  Notification = 'NOTIFICATION',
  Attachment = 'ATTACHMENT',
  AttachmentAssociation = 'ATTACHMENT_ASSOCIATION',
  Document = 'DOCUMENT',
  DocumentComment = 'DOCUMENT_COMMENT',
  Approvals = 'APPROVALS',
  Space = 'SPACE',
  ProjectMembers = 'PROJECT_MEMBERS',
  ProjectMembersV2 = 'PROJECT_MEMBERS_V2', // * Used in RM
  TimesheetComment = 'TIMESHEET_COMMENT',
  ResourceAllocation = 'RESOURCE_ALLOCATION',
  AccountMembers = 'ACCOUNT_MEMBERS',
  ProjectSpace = 'PROJECT_SPACE',
  SpaceTab = 'SPACE_TAB',
  AsyncProcessor = 'ASYNC_PROCESSOR',
  ConversationReadReceipt = 'CONVERSATION_COMMENT_READ_RECEIPT',
  ProjectFinanicalField = 'FINANCIAL',
}

export interface AccountSocketData<T> {
  accountId: number;
  valueAt: number;
  action: Action;
  objectType: ObjectType;
  requestId: string;
  data: T;
}

export interface SocketData<T> extends AccountSocketData<T> {
  projectId: number;
  actionBy: number;
}

export interface TeamSocketData<T> extends AccountSocketData<T> {
  projectId?: number;
}

export type EventType = [Action, ObjectType];
export const EventType = (action: Action, type: ObjectType): EventType => [
  action,
  type,
];
